import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  text: 'La mesa rebatible me dio $480.000 ARS. El combo se pagó 24 veces solo.',
  author: 'Marcelo R., Buenos Aires'
}, {
  text: 'Planos de Cama Murphy clarísimos. Primer intento perfecto. 3 referidos nuevos.',
  author: 'Jorge C., Rosario'
}, {
  text: 'Subí mi ticket promedio un 45% con los scripts de venta del Bono 4.',
  author: 'Sofía V., Córdoba'
}, {
  text: 'Set de 20 sillas para eventos: $1.400.000 ARS. Me cambió el negocio.',
  author: 'Carolina M., Entre Ríos'
}];
export function Testimonials() {
  return <section className="py-12 md:py-16 bg-cream-dark" data-id="element-220">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-221">
        <h2 className="text-2xl md:text-3xl font-black text-wood-dark mb-8 text-center" data-id="element-222">
          LO QUE DICEN LOS QUE YA FABRICAN
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-223">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="bg-white p-5 rounded-xl shadow-warm border border-wood-light/10" data-id="element-224">
              <div className="flex mb-2" data-id="element-225">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 text-amber fill-amber" data-id="element-226" />)}
              </div>
              <p className="text-charcoal/80 italic text-sm mb-3 leading-relaxed" data-id="element-227">
                "{t.text}"
              </p>
              <p className="font-bold text-wood-dark text-sm" data-id="element-228">— {t.author}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}